 .labelComment {
    margin-left: 6px !important;
    color: #667885 !important;
  }

.inputContainer {
  width: 100%;
  box-sizing: border-box;

  .noBorder {
    border: none;
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 12px;
    cursor: pointer;
    font-size: inherit;
  }

  .withIcon {
    padding-left: 36px;
  }

  .clearIcon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 24px;
    cursor: pointer;
    display: none;

    &.active {
      display: block;
    }
  }
}
